define(function(require, exports, module) {
    'use strict';

    var i18n = require('i18n');
    var userValidation = require('modules/user/user.validation.config');

    module.exports = function() {
        var config = userValidation();
        var passwordRegExp = /^(?! )(?!.* $)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*['«!"#$%&/()=?»|*+ºª\-_<>^~´`¨.:,;{}[\]])[«»ºª´`¨ -~]{8,}$/;

        config.zip.fn.fn = function($inputs, cfg, form) {
            var zip = $inputs.val().replace(/\s/g, '');
            var isPortugal = form.countryCode === 'PT';

            $inputs.val(zip);

            return isPortugal ? /^(\d{4})-(\d{3})*$/.test(zip) : true;
        };

        config.email = {
            required: {
                message: i18n.t('playtech.mobile.system.user.tooltip.email.required')
            },
            length: {
                min: 8,
                max: 100,
                message: i18n.t('playtech.mobile.system.user.tooltip.email.length')
            },
            regexp: {
                regexp: /^(.[\S]*)@((.[\S]*\.)+.{2,})$/,
                message: i18n.t('playtech.mobile.system.user.tooltip.email.regexp')
            }
        };

        config.password.regexp = {
            regexp: passwordRegExp,
            message: i18n.t('playtech.mobile.system.user.tooltip.password.regexp')
        };

        config.password.length = {
            min: 8,
            max: 30,
            message: i18n.t('playtech.mobile.system.user.tooltip.password.length')
        };

        return config;
    };
});
